import React from "react"
import styled from "styled-components"
import { Link } from "gatsby"
import { FaFacebook, FaInstagram, FaYoutube, FaTwitter } from "react-icons/fa"


const Footer = () => {

    const links = {
        AboutUs : [
          {
            Text: 'Home',
            Link: '/'
          },
          {
            Text: 'Admissions',
            Link: '/admissions/'
          },
          {
            Text: 'Education',
            Link: '/institutions/'
          },
          {
            Text: 'Amenities',
            Link: '/amenities/'
          },

          {
            Text: 'About Us',
            Link: '/about/'
          },
        ],
        Institutions : [
          {
            Text: 'Engineering',
            Link: '/institutions/#engineering'
          },
          {
            Text: 'Pharmacy',
            Link: '/institutions/#pharmacy'
          },
          {
            Text: 'Management',
            Link: '/institutions/#mba'
          },
          {
            Text: 'Polytechnic',
            Link: '/institutions/#polytechnic'
          },
          {
            Text: 'Junior College',
            Link: '/institutions/#parikrama-science-academy'
          },
          {
            Text: 'CBSE School',
            Link: '/institutions/#cbse-school'
          },
        ],
        Campus : [
          {
            Text: 'Location',
            Link: 'https://maps.app.goo.gl/W5DtNh6oCe9Qr6jJ6'
          },
          {
            Text: 'Contact Us',
            Link: '/#contact'
          },
          {
            Text: 'Activities',
            Link: ''
          },
          {
            Text: 'News',
            Link: '/news/'
          },
          {
            Text: 'Gallery',
            Link: '/gallery/'
          },

        ],
        OtherLinks : [
          {
            Text: 'NAAC',
            Link: '/nss/'
          },
          {
            Text: 'Antiragging',
            Link: `/antiragging/`
          },
          {
            Text: 'Greivance Redress',
            Link: 'https://parikramamba.smartschoolmis.com/studentinfosys/studentportal/studinfo_studlogin.aspx'
          },
          {
            Text: 'SIF',
            Link: '/sif/'
          },
          {
            Text: 'Alumni',
            Link: 'https://docs.google.com/forms/d/e/1FAIpQLScPgTdq_qk1wAnzISJv6j9eL0xEaA2naT4EWrtxhndtFEXsUQ/viewform'
          },
          {
            Text: 'SPPU',
            Link: '//www.unipune.ac.in'
          },
          {
            Text: 'DTE',
            Link: '//www.dtemaharashtra.gov.in'
          },
            {
            Text: 'Disclosures',
            Link: '/disclosures/'
          },
            {
            Text: 'ekeeda',
            Link: 'https://ekeeda.com/catalog/academic'
          },
        ]
      }


    return (
        <>
        <Text >
           A Part Of Hon. Shree Babanrao Pachpute Vichardhara Trust
        </Text>
        <Wrapper>
            <LinkSection>
                <Section>
                    <Title>
                        About Us
                    </Title>
                    <Links>
                    <ul>
                        {links.AboutUs.map((link, index)=>{
                            return(
                                <li key={index}>
                                    <Link to={link.Link} target='_blank' rel="noreferrer">{link.Text}</Link>
                                </li>
                            )

                        })}
                    </ul>
                    </Links>
                </Section>
                <Section>
                    <Title>
                       Institutions
                    </Title>
                    <Links>
                    <ul>
                        {links.Institutions.map((link, index)=>{
                            return(
                                <li key={index}>
                                    <Link to={link.Link} target="_blank" rel="noreferrer">{link.Text}</Link>
                                </li>
                            )

                        })}
                    </ul>
                    </Links>
                </Section>
                <Section>
                    <Title>
                       Campus
                    </Title>
                    <Links>
                    <ul>
                        {links.Campus.map((link, index)=>{
                            return(
                                <li key={index}>
                                    <Link to={link.Link} target="_blank" rel="noreferrer">{link.Text}</Link>
                                </li>
                            )

                        })}
                    </ul>
                    </Links>
                </Section>
                <Section>
                    <Title>
                       Other Links
                    </Title>
                    <Links>
                    <ul>
                        {links.OtherLinks.map((link, index)=>{
                            return(
                                <li key={index}>
                                    <Link to={link.Link} target="_blank" rel="noreferrer">{link.Text}</Link>
                                </li>
                            )

                        })}
                    </ul>
                    </Links>
                </Section>
            </LinkSection>
        </Wrapper>
        <InfoWrapper>
            <Address>
                Hon. Shri Babanrao Pachpute Vichardhara Trust's Parikrama Technical Campus,Parikrama Village, Kashti, Tal: Shrigonda, Dist: Ahmednagar, Maharashtra,INDIA <br /><br />
                <Address1>T: 8751005005</Address1>
            </Address>
            <Social>
                <div style={{width:'25%', textAlign:'center', fontSize:'1.7rem'}}>
                    <a href='https://www.facebook.com/parikramacollegecampus'><FaFacebook /></a>
                </div>
                <div style={{width:'25%', textAlign:'center', fontSize:'1.7rem'}}>
                    {<a href='https://www.instagram.com/parikramagroupofinstitutions/'><FaInstagram /></a>}
                </div>
                <div style={{width:'25%', textAlign:'center', fontSize:'1.7rem'}}>
                    <a href='https://youtube.com/channel/UCP2xAD0QiO76fHfqiJlXnlg'><FaYoutube /></a>
                </div>
                <div style={{width:'25%', textAlign:'center', fontSize:'1.7rem'}}>
                    <a href='https://twitter.com/parikramacampus'><FaTwitter /></a>
                </div>
            </Social>
        </InfoWrapper>
        <CopyrightText>
                © {new Date().getFullYear()}, All Rights Reserved, Parikrama
                <p>Designed and Developed by <a href="https://tweely.co" target="_blank" rel="noreferrer" style={{color: 'var(--primaryRed)', fontWeight: 'bold', textDecoration:'none'}}>Tweely</a></p>
        </CopyrightText>
        
        <div id="whatsapp-widget-timelines" className="ww-right ww-normal">
          <a href="https://wa.me/+918751005005/?text=Hello!" className="ww-text">Message us</a>
          <div className="ww-icon">
            <a href="https://wa.me/+918751005005/?text=Hello!">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
                <path d=" M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39a.63.63 0 0 1-.315-.1c-.802-.402-1.504-.817-2.163-1.447-.545-.516-1.146-1.29-1.46-1.963a.426.426 0 0 1-.073-.215c0-.33.99-.945.99-1.49 0-.143-.73-2.09-.832-2.335-.143-.372-.214-.487-.6-.487-.187 0-.36-.043-.53-.043-.302 0-.53.115-.746.315-.688.645-1.032 1.318-1.06 2.264v.114c-.015.99.472 1.977 1.017 2.78 1.23 1.82 2.506 3.41 4.554 4.34.616.287 2.035.888 2.722.888.817 0 2.15-.515 2.478-1.318.13-.33.244-.73.244-1.088 0-.058 0-.144-.03-.215-.1-.172-2.434-1.39-2.678-1.39zm-2.908 7.593c-1.747 0-3.48-.53-4.942-1.49L7.793 24.41l1.132-3.337a8.955 8.955 0 0 1-1.72-5.272c0-4.955 4.04-8.995 8.997-8.995S25.2 10.845 25.2 15.8c0 4.958-4.04 8.998-8.998 8.998zm0-19.798c-5.96 0-10.8 4.842-10.8 10.8 0 1.964.53 3.898 1.546 5.574L5 27.176l5.974-1.92a10.807 10.807 0 0 0 16.03-9.455c0-5.958-4.842-10.8-10.802-10.8z" fillRule="evenodd"></path>
              </svg>
            </a>
          </div>
        </div>
         
        </>
    )
}

export default Footer


const Wrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    background-color: var(--primaryBlack);
    @media only screen and (max-width: 1086px){
    flex-direction: column;
  }
`

const Text = styled.div`
    width: 100%;
    color: var(--textRed);
    padding: var(--spacer-3);
    background-color: var(--primaryGrey);
    
    // Font
    font-family: var(--headerFont);
    font-style: normal;
    font-weight: bold;
    font-size: var(--font-3);
    line-height: 1.5;
    text-align: center;
    text-transform: uppercase;
`
const LinkSection = styled.div`
    padding-top: 1rem;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-gap: 2rem;
    grid-auto-columns: 1fr;
    grid-auto-rows: 1fr;
    @media only screen and (max-width: 780px){
    grid-template-columns: repeat(2, 1fr);
  }
`
const Section = styled.div`
    display: flex;
    padding: 0 4rem 0 1rem;
    align-items: start;
    flex-direction: column;

`
const Title = styled.div`
    font-size: var(--font-3);
    line-height: 1.5rem;
    font-family: var(--headerFont);
    color:  var(--textRed);
    font-weight: 400;
`
const Links = styled.div`
  
    ul{
        list-style: none;
        margin: 0;
        font-family: var(--bodyFont);
        li{
            margin-bottom: 0;
            font-size: var(--font-2);
            font-family: var(--bodyFont);
            a{
                text-decoration: none;
                color: var(--primaryGrey);

                :visited, :active{
                    text-decoration: none;
                    color: var(--primaryGrey);
                }

                :hover {
                    color: var(--textRed);
                }
            }
        }
    }
`

const InfoWrapper = styled.div`
    display: flex;
    flex-direction: row;
    padding: 2rem;
    width: 100%;
    background-color: var(--primaryBlack);    
    @media only screen and (max-width: 1086px){
    flex-direction: column-reverse;   
  }
`

const CopyrightText = styled.div`
    font-family: var(--bodyFont);
    text-align: center;
    padding: var(--spacer-3);
    width: 100%;
    background-color: var(--primaryBlack);
    color: var(--primaryGrey);
`

const Address = styled.div`

    font-family: var(--bodyFont);
    font-size: var(--font-3);
    width: 60%;
    float: left;
    color: var(--primaryGrey);
    @media only screen and (max-width: 1086px){
        width: 100%;
  }
`
const Address1 = styled.div`

    
    font-size: var(--font-5);
    
`

const Social = styled.div`
    width: 40%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    @media only screen and (max-width: 1086px){
        width: 100%;
        padding: var(--spacer-5);
  }

  >div {

        width: 25%;
        text-align:center;
        font-size: var(--font-5);

      a{    
            color: var(--primaryGrey);
            transition: all 0.2s ease-in-out;
            :hover{
              color: var(--textRed);
              transform: scale(1.2);
              transition: all 0.2s ease-in-out;
          }
      }
  }

`
